












































import { Component, Vue } from 'vue-property-decorator';
import { UserInfo } from '@/interfaces/vuexStateInterface';
import { checkVerify, getFigureCode, sendEmailCode, updateEmail } from '@/apis/myInfo/myInfo.ts';
import i18n from '@/lang';

@Component({})
export default class OnBindEmail extends Vue {
  // private bindRouter: any = ''
  private isShowPopUp: boolean = false; // 验证码弹窗
  private checkPicCodeInputError: boolean = false;
  private picCodeUrl: any = ''; // 图形验证码地址
  private picCodeInput: string = '';
  private sessionid: any = '';
  private codeFailMsg: string = i18n.t('ktpMy.请输入正确的验证码') as string;
  private virtCode: string = ''; // 验证码
  private emailText: string = '';
  private veriCode: string = '';
  private dowmEmail: boolean = false;
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }
  private warnInfo: boolean = false;

  // 验证码确定
  confirmPicCode() {
    sendEmailCode({ verify: this.picCodeInput, email: this.emailText, sessionid: this.sessionid, type: 'reg' })
      .then((res: any) => {
        // 说明输入正确
        this.checkPicCodeInputError = false;
        this.isShowPopUp = false;
        this.dowmEmail = true;
      })
      .catch(e => {
        this.dowmEmail = false;
        this.checkPicCodeInputError = true;
        this.codeFailMsg = e.message;
        this.getPicCode();
      });
  }
  keep() {
    if (this.dowmEmail) {
      // 绑定邮箱
      updateEmail({ code: this.veriCode, email: this.emailText }).then(res => {
        this.$store.dispatch('setUserInfo').then(() => {
          this.$router.push('myAllSetting?detail=myAccountManage');
          this.$toast(i18n.t('Common.修改成功'));
        });
      });
    } else {
      const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (reg.test(this.emailText)) {
        // 进行请求验证码操作
        this.isShowPopUp = true;
        this.getPicCode();
      } else {
        this.warnInfo = true;
      }
    }
  }
  // mounted() {
  //   this.bindRouter = this.$route.query.bind
  // }
  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.邮箱') as string,
      showTitle: true
    });
  }
  // 请求验证码
  getPicCode() {
    getFigureCode()
      .then((res: any) => {
        this.sessionid = res.sessionid;
        this.picCodeUrl = res.url;
      })
      .catch(e => {
        this.$toast.fail(e.message);
      });
  }
}
